import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from 'redux/store';
import routes from 'constants/routes';
import EditContainer from 'components/Common/EditContainer';
import ProfileContainer from 'components/Account/ProfileContainer';

function MyAccountEditInfo() {
    const { userInfo, userResponse, address } = useSelector((state: RootState) => state.user);
    const { firstName, lastName, username, telephone, email, imgUrl } = userInfo || {};
    const { catholicDirectoryAccountNumber, parishName } = userResponse || {};
    const { street1: address1, street2: address2, city, state, country, zipCode: zip } = address || {};
    const defaultValues = {
        firstName,
        lastName,
        username,
        telephone,
        email,
        address: {
            address1,
            address2,
            city,
            state,
            country,
            zip,
        },
        catholicDirectoryAccountNumber,
        parishName,
    };
    let navigate = useNavigate();

    const navigationHandler = () => {
        navigate(routes.account.changePhoto);
    };
    return (
        <div>
            <EditContainer type="account" defaultValues={defaultValues}>
                <ProfileContainer imageUrl={imgUrl} navigationHandle={navigationHandler} />
            </EditContainer>
        </div>
    );
}

export default MyAccountEditInfo;
